import { useState } from 'react';

import { useFetch, useListFetch, useRequest } from '../../hooks';
import { getContact, getMessages, sendChatToServer } from '../../api';
import type { MessageItem, GetMessagesFilter } from '../../api';

export const useMessagesForContact = (contactId: string) => {
  const [chat, setChat] = useState('');
  const { data: contact } = useFetch(() => getContact(contactId), [contactId]);

  const result = useListFetch<MessageItem, GetMessagesFilter>(
    async params => {
      const result = await getMessages(params.filters);
      if (!result) return { content: [] };

      return { content: result.messages };
    },
    {
      deps: [contactId],
      withQueryParams: true,
      initialFilters: contactId ? { contactId } : {},
    }
  );

  const [sendChat, sending] = useRequest(
    async () => {
      if (!contactId || !chat.length) return;

      return sendChatToServer(contactId, chat);
    },
    {
      deps: [chat, contactId],
      onSuccess: () => {
        setChat('');
        result.refresh();
      },
    }
  );

  return {
    ...result,
    sending,

    chat,
    setChat,
    sendChat,

    contact,
  };
};

export type Item = MessageItem;
